import dynamic from "next/dynamic";

import React from "react";

import { twMerge } from "tailwind-merge";

import AccountUpgradeForm from "components/AccountUpgradeForm";
import useMediaQuery from "hooks/useMediaQuery";

const Modal = dynamic(() => import("react-modal"), { ssr: false });

const AccountUpgradeModal = ({
  onClose,
  defaultPlan,
}: {
  onClose?: () => void;
  defaultPlan?: any;
}) => {
  const { mobile } = useMediaQuery();

  return (
    <Modal
      portalClassName="z-[1999]"
      overlayClassName={
        mobile
          ? "z-[1999] fixed inset-0 p-[15px] pt-[50px] bg-[rgba(31,31,32,.77)] overflow-y-auto overflow-x-hidden"
          : "z-[1999] fixed inset-0 bg-[rgba(31,31,32,.77)] overflow-y-auto"
      }
      className={twMerge(
        mobile
          ? "top-[50px] px-[25px] py-[30px]"
          : "relative w-[720px] mx-auto my-[130px]",
        "outline-none rounded-xl bg-white",
        "flex flex-col"
      )}
      isOpen
      onAfterOpen={() => {
        document.body.style.overflowY = "hidden";
      }}
      onAfterClose={() => {
        document.body.style.overflowY = "";
      }}
      onRequestClose={onClose}
    >
      <AccountUpgradeForm className="mb-0" defaultPlan={defaultPlan} />
      <button
        className="absolute top-[-5px] right-[10px] border-0 bg-transparent text-[40px] text-white hover:text-active-black"
        onClick={onClose}
      >
        ×
      </button>
    </Modal>
  );
};

export default AccountUpgradeModal;
